{
    "uz": {
        "Yes": "Ha",
        "No": "Yo'q",
        "Cancel": "Bekor qilish",
        "Close": "Yopish",
        "Clear": "Tozalash",
        "Done": "Bajarildi",
        "Loading": "Yuklanmoqda...",
        "Select": "Tanlash...",
        "Search": "Qidirish",
        "Back": "Orqaga",
        "OK": "OK",
        "dxCollectionWidget-noDataText": "Ma'lumot yo'q",
        "dxList-pullingDownText": "Yangilash uchun pastga torting...",
        "dxList-pulledDownText": "Yangilash uchun qo'yib yuboring...",
        "dxList-refreshingText": "Yangilanmoqda...",
        "dxList-pageLoadingText": "Yuklanmoqda...",
        "dxList-nextButtonText": "Ko'proq",
        "dxList-selectAll": "Hammasini tanlash",
        "dxDataGrid-noDataText": "Ma'lumot yo'q"
    }
}
